import { LegacyEvent } from '../mdl/zzz-legacy-open-events';
import { MEFriendModel } from '../me/friends';
import { UIDialog } from '../ui/component/dialog';
import { $el } from '../ui/elements';
import { UIView } from '../ui/view';
import { YId } from '../y/types';

export function makeFriendCircle(first_name: string, last_name: string, avatar_id?: YId) {
    if(avatar_id)
        return $el.BACK({ media: avatar_id }, 'tl-friend-circle');
    else
        return $el.DIV('tl-friend-circle', (first_name.substring(0, 1) + last_name.substring(0, 1)));
}

class TLFriendsDialog extends UIDialog {
    constructor(event: LegacyEvent, friends: MEFriendModel[]) {
        super({ close: true, classes: 'm-550' });

        const table = $el.DIV('tl-friends-table');

        for(const f of friends) {
            if(!f.booked_sessions)
                continue;

            for(const s of event.active_sessions) {
                if(f.booked_sessions.includes(s.id)) {
                    table.ui_add($el.DIV('r-row', [
                        makeFriendCircle(f.first_name, f.last_name, f.avatar),
                        $el.I(f.first_name + ' ' + f.last_name),
                        $el.S(),
                        $el.SPAN('r-time', s.time_y.format('d MMM HH:mm'),)
                    ]));
                }
            }
        }

        this.content.ui_add($el.DIV('w-block l-form m-center', [
            $el.H2('title', "Vänner som ska gå"),
            $el.DIV('tl-time-or-place', event.name),
            table
        ]));
    }
}

export class TLFriendsWidget extends UIView {
    constructor(event: LegacyEvent, friends: MEFriendModel[]) {
        super('div', 'tl-friends-widget');

        let count = 0;

        for(const f of friends) {
            this.ui_add(makeFriendCircle(f.first_name, f.last_name, f.avatar));

            if(++count == 4 && friends.length > 5) {
                this.ui_add($el.DIV('tl-friend-circle m-text', '+' + (friends.length - 4)));
                break;
            }
        }

        this.root.addEventListener('click', e => {
            const elem = e.target as HTMLElement;
            if(elem.matches('.tl-friend-circle')) {
                e.stopPropagation();
                new TLFriendsDialog(event, friends).present();
            }
        });
    }
}
